import { computed } from 'vue'
import { useRoute } from 'vue-router'

/**
 * The key of a routed PAGE: fullPath by default, so any query change remounts
 * it (the historical rule); routes that own their query (`meta.ownsQuery`)
 * remount only when the path changes; sibling addresses of one page share a
 * `meta.viewKey` (the Pilotage sections, MYAC-1522) and remount only on a
 * project switch.
 *
 * A project shell (`meta.projectShell`: the QMS or product frame with its menu
 * and score) is NOT keyed by this: HomeView keys it by project, so moving
 * between a project's pages keeps the menu still (the score used to vanish and
 * come back, shifting the menu); the shell keys its own inner page with this.
 */
export function usePageViewKey() {
  const route = useRoute()
  return computed(() => route.meta.viewKey
    ? `${String(route.meta.viewKey)}:${String(route.params.pid ?? '')}`
    : route.meta.ownsQuery ? route.path : route.fullPath)
}

/** HomeView's key: one per project for a project shell, the page key otherwise. */
export function useShellViewKey() {
  const route = useRoute()
  const pageKey = usePageViewKey()
  return computed(() => route.meta.projectShell
    ? `shell:${route.path.split('/')[1] ?? ''}:${String(route.params.pid ?? '')}`
    : pageKey.value)
}
